import axios from "axios";
import isEqual from "lodash/isEqual";
import VueRouter from "vue-router";
import qs from "qs";

export function createRouter({ routes, base }) {
    return new VueRouter({
        routes,
        base,
        mode: 'history',
        parseQuery: query => qs.parse(query, { strictNullHandling: true }),
        stringifyQuery: query => qs.stringify(query, { addQueryPrefix: true, skipNulls: true }),
    });
}

export function search(vm, request) {
    vm.error = null;
    vm.loading = true;
    if(vm.cancelSearch) {
        vm.cancelSearch();
    }
    return request({ cancelToken: new axios.CancelToken(c => vm.cancelSearch = c) })
        .then(() => {
            vm.$emit('results');
            vm.loading = false;
        })
        .catch(error => {
            if(axios.isCancel(error)) {
                return Promise.reject(error);
            }
            vm.loading = false;
            vm.error = 'Une erreur est survenue lors de la recherche';
            return Promise.reject(error);
        });
}

export function routesEquals(route, oldRoute) {
    return route && oldRoute && isEqual(route.query, oldRoute.query);
}

export function setup(vm, getOptions) {
    return vm.init()
        .then(() => {
            const { route } = getOptions();
            vm.$router.replace(route)
                .catch(error => {
                    console.error(error);
                });
            vm.$watch('$route', vm.init);
            vm.$emit('ready');
            vm.ready = true;
        })
        .catch(error => {
            // if error occurred with current query: redirect to /
            if(location.search) {
                vm.$router.replace({ name: 'home' });
                vm.setup();
            }
            return Promise.reject(error);
        });
}

export function onMounted(vm) {
    window.addEventListener('popstate', vm.onPopState = () => {
        // force refresh when go to previous page (ios filters empty bug)
        vm.hydratingKey++;
        // refresh after results received to sync current filters state
        vm.$once('results', async () => {
            await vm.$nextTick();
            vm.hydratingKey++;
        });
    });
    vm.$once('hook:beforeDestroy', () => {
        window.removeEventListener('popstate', vm.onPopState);
    })
}
